// extracted by mini-css-extract-plugin
export var card = "_aa-1";
export var container = "_aa-0";